import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Card from "../../components/layouts/Card";
import { RootState } from "../../redux/rootReducers";

const AuthenticationLoadingPage = () => {
  const [theDots, setDots] = useState<string>("");

  const isLoading = useSelector((state: RootState) => state.authorization.isLoading);
  const authorizedUser = useSelector((state: RootState) => state.authorization.token);

  useEffect(() => {
    if (isLoading) {
      if (theDots === '.....') {
        setDots('');
      } else {
        setTimeout(() => {
          setDots(theDots + ".");
        }, 250);
      }
    }
  }, [theDots, isLoading]);

  if (!isLoading) return <div />
  
  return (
    <Card style={{maxWidth: '400px'}}>
      <div className="card--title">
        <h2 className="card--title-title">Memuat Data{theDots}</h2>
      </div>
      <div className="card--body">
        Mohon menunggu sebentar, kami sedang menyiapkan sesuatu yang keren!
      </div>
    </Card>
  )
}

export default AuthenticationLoadingPage; 